import { RafflePrimaryInfoVisitor } from "@components/raffles/visitor/primaryInfo";
import { RaffleOwnerResultInfo } from "@components/raffles/owner/resultInfo";
import { RaffleRewardVisitor } from "@components/raffles/visitor/reward";
import { RaffleSummaryVisitor } from "@components/raffles/visitor/summary";
import { RaffleTicketVisitor } from "@components/raffles/visitor/tickets";
import { IRaffleDefaultDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { RaffleStatusEnum } from "@hooks/enums/raffle";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export function DefaultRaffleVisit() {
  const [searchParams] = useSearchParams();
  const key = searchParams.get("key");
  const campaign = searchParams.get("campaign");

  const [raffle, setRaffle] = useState<IRaffleDefaultDTO>();

  return (
    <>
      {key && (
        <RafflePrimaryInfoVisitor
          raffleKey={key}
          campaign={campaign || ""}
          retRaffle={setRaffle}
        />
      )}

      {key && raffle && (
        <RaffleSummaryVisitor
          raffleKey={key}
          campaign={campaign || ""}
          raffle={raffle}
        />
      )}

      {key && raffle?.status === RaffleStatusEnum.FINISHED && (
        <RaffleOwnerResultInfo
          raffleKey={key}
          resultScheduleEndpoint="/raffleClient/default/result/schedule"
        />
      )}

      {key && <RaffleTicketVisitor raffleKey={key} campaign={campaign || ""} />}

      {key && <RaffleRewardVisitor raffleKey={key} campaign={campaign || ""} />}
    </>
  );
}
